import { Component, Input, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SalesforceErrorService } from './salesforce-error.service';
import { SalesforceError } from '../salesforce-data.model';

@Component({
  selector: 'app-salesforce-error',
  templateUrl: './salesforce-error.component.html',
  styleUrls: ['./salesforce-error.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SalesforceErrorComponent implements OnInit, OnDestroy {
  @Input()
  public chatId: string;

  public message: string;
  public isVisible: boolean = false;
  public subscription: Subscription;
  constructor(private _salesforceErrorService: SalesforceErrorService) {}

  public ngOnInit(): void {
    this.subscription = this._salesforceErrorService.onError.pipe(filter(error => error.chatId === this.chatId))
      .subscribe(this._onError.bind(this));
  }

  public ngOnDestroy(): void {
    if (typeof this.subscription !== 'undefined') {
      this.subscription.unsubscribe();
    }
  }

  private _onError(error: SalesforceError): void {
    this.isVisible = error.visible;
    this.message = error.message;
  }
}
